import { gql } from "graphql-request";

export const INSERT_EVENT = gql`
  mutation InsertEvent(
    $title: String!
    $description: String
    $singleDay: Boolean!
    $startTime: DateTime!
    $endTime: DateTime!
    $locationName: String!
    $locationLat: Float!
    $locationLng: Float!
    $categoryIds: [String!]!
    $coverImage: String
    $visibility: String!
    $registrationPolicy: String!
    $capacity: Int
    $groupIds: [String]
    $attachmentUrls: [String]
    $firstName: String!
    $lastName: String!
    $email: String!
    $profileImageUrl: String
    $organizationIds: [String]
  ) {
    insertevent(
      input: {
        OrganizationIds: $organizationIds
        title: $title
        description: $description
        singleDay: $singleDay
        startTime: $startTime
        endTime: $endTime
        locationName: $locationName
        locationLat: $locationLat
        locationLng: $locationLng
        categoryIds: $categoryIds
        coverImage: $coverImage
        visibility: $visibility
        registrationPolicy: $registrationPolicy
        capacity: $capacity
        groupIds: $groupIds
        attachmentUrls: $attachmentUrls
        eventOrganizerSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;
export const GET_EVENTS = gql`
  query GetEvents(
    $filter: String
    $sort: String
    $pageNo: Int
    $pageSize: Int
  ) {
    getevents(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationIds
        Tags
        DeletedDate
        title
        description
        singleDay
        startTime
        endTime
        locationName
        locationLat
        locationLng
        coverImage
        visibility
        registrationPolicy
        capacity
        categoryIds
        groupIds
        attachmentUrls
        eventOrganizerSnapshot {
          firstName
          lastName
          email
          profileImageUrl
        }
      }
    }
  }
`;

export const UPDATE_EVENT = gql`
  mutation UpdateEvent(
    $filter: String!
    $title: String!
    $description: String!
    $singleDay: Boolean!
    $startTime: DateTime!
    $endTime: DateTime!
    $locationName: String!
    $locationLat: Float!
    $locationLng: Float!
    $categoryIds: [String!]!
    $coverImage: String
    $visibility: String!
    $registrationPolicy: String!
    $capacity: Int
    $groupIds: [String!]!
    $attachmentUrls: [String!]
  ) {
    updateevent(
      filter: $filter
      input: {
        title: $title
        description: $description
        singleDay: $singleDay
        startTime: $startTime
        endTime: $endTime
        locationName: $locationName
        locationLat: $locationLat
        locationLng: $locationLng
        categoryIds: $categoryIds
        coverImage: $coverImage
        visibility: $visibility
        registrationPolicy: $registrationPolicy
        capacity: $capacity
        groupIds: $groupIds
        attachmentUrls: $attachmentUrls
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_EVENT = gql`
  mutation DeleteEvent($filter: String!) {
    deleteevent(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every event created by a user (used by the user-deletion purge).
export const DELETE_MANY_EVENT_BY_CREATOR = gql`
  mutation DeleteManyEventByCreator($createdBy: String!) {
    deleteManyevent(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;
// RSVP
export const GET_RSVPS = gql`
  query GetRSVPs(
    $filter: String!
    $sort: String!
    $pageNo: Int!
    $pageSize: Int!
  ) {
    getRSVPs(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationIds
        Tags
        DeletedDate
        eventId
        status
        eventParticipantSnapshot {
          firstName
          lastName
          email
          profileImageUrl
        }
      }
    }
  }
`;

export const INSERT_RSVP = gql`
  mutation InsertRSVP(
    $eventId: String!
    $status: String!
    $firstName: String!
    $lastName: String!
    $email: String!
    $profileImageUrl: String
    $organizationIds: [String]
  ) {
    insertRSVP(
      input: {
        OrganizationIds: $organizationIds
        eventId: $eventId
        status: $status
        eventParticipantSnapshot: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          profileImageUrl: $profileImageUrl
        }
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const UPDATE_RSVP = gql`
  mutation UpdateRSVP($filter: String!, $status: String!) {
    updateRSVP(filter: $filter, input: { status: $status }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_RSVP = gql`
  mutation DeleteRSVP($filter: String!) {
    deleteRSVP(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every RSVP created by a user (used by the user-deletion purge).
export const DELETE_MANY_RSVP_BY_CREATOR = gql`
  mutation DeleteManyRSVPByCreator($createdBy: String!) {
    deleteManyRSVP(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;
// event gallery
export const GET_EVENT_GALLERY = gql`
  query GetEventGallery(
    $filter: String!
    $sort: String!
    $pageNo: Int!
    $pageSize: Int!
  ) {
    geteventgallerys(
      input: {
        filter: $filter
        sort: $sort
        pageNo: $pageNo
        pageSize: $pageSize
      }
    ) {
      totalCount
      totalPages
      hasNextPage
      hasPreviousPage
      items {
        ItemId
        CreatedDate
        CreatedBy
        LastUpdatedDate
        LastUpdatedBy
        Language
        OrganizationIds
        Tags
        DeletedDate
        eventId
        imageUrl
      }
    }
  }
`;

export const INSERT_EVENT_GALLERY = gql`
  mutation InsertEventGallery(
    $eventId: String!
    $imageUrl: String!
    $organizationIds: [String]
  ) {
    inserteventgallery(
      input: {
        eventId: $eventId
        imageUrl: $imageUrl
        OrganizationIds: $organizationIds
      }
    ) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

export const DELETE_EVENT_GALLERY = gql`
  mutation DeleteEventGallery($filter: String!) {
    deleteeventgallery(filter: $filter, input: { isHardDelete: true }) {
      acknowledged
      totalImpactedData
      itemId
    }
  }
`;

// Bulk delete: every event gallery created by a user (used by the user-deletion purge).
export const DELETE_MANY_EVENT_GALLERY_BY_CREATOR = gql`
  mutation DeleteManyEventGalleryByCreator($createdBy: String!) {
    deleteManyeventgallery(
      where: { CreatedBy: { eq: $createdBy } }
      input: { isHardDelete: true }
    ) {
      acknowledged
      totalImpactedData
      itemId
      message
    }
  }
`;
